module.exports = __webpack_public_path__ + "static/media/Siren.2784da98.mp3";